<template>
<section>
    <div class="wrap">
        <div class="notice_view_info onenone_type">
            <div>
                <p>분류 {{faqType(qnaItem.type)}} </p>
                <span :class="{'answer_ok': (qnaItem.status == QNA_STATUS.COMPLETE.id)}">{{qnaStatus(qnaItem.status)}}</span>
            </div>
            <p class="title">{{qnaItem.title}}</p>
        </div>
    </div>
    <div class="wrap">     
        <div class="onenone_view">
            <div class="contents">{{qnaItem.content}}</div>
            <template v-if="qnaItem.answer">
                <div class="contents">{{qnaItem.answer}}</div>
            </template>
            
        </div>
    </div>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { FaqFormatMixin } from '../../mixins/FaqFormatMixin';

export default {
    name:'QnaInfo',
    mixins: [FaqFormatMixin],
    async created () {
        await this.getItem();
        this.$store.commit('SHOW_ONLOAD');
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapState({
            qnaItem: state => state.qna.item,
        }),
        qnaId(){
            return this.$route.params.qnaId;
        }
    },
    methods: {
        getItem() {
            this.$store.dispatch('GET_QNA', this.qnaId)
        }
    },
}
</script>

<style lang="scss" scoped>

</style>